import React, {useState} from 'react';
import { CSVReader } from 'react-papaparse';
import firebase from 'firebase/app';

//components
import ImportExampleV2 from '../popover/ImportExampleV2';

export default function ContactsHeadingV2({profile, auth, checkedContacts}) {

    // const [ showReader, setShowReader ] = useState(false)
    const showReader = false
    const [ conLink, setConLink ] = useState('')

    const handleOnDrop = (data) => {
        // console.log(data)

        for (let i = 0; i < 30; i++) {
            var newDoc = firebase
                          .firestore()
                          .collection('organizations')
                          .doc(profile.company)
                          .collection('importedContacts')
                          .doc()

            if(data[i] !== undefined){
            if(data[i].data[i - i + 0 ].includes("linkedin.com/in")){
            newDoc
            .set({
                id: newDoc.id,
                createdBy: profile.email,
                authorCompany: profile.company,
                authorID: auth.uid,
                authorFirstName: profile.firstName,
                authorLastName: profile.lastName,
                contactLinkedin: data[i].data[i - i + 0 ],
                createdAt: new Date()
                
            })
            .then(function () {
                //console.log('Document Added ');
            })
            .catch(function (error) {
                console.error('Error adding document: ', error);
            });
            }
        }
            
        }
    }

    const handleOnError = (err, file, inputElem, reason) => {
        console.log(err)
    }

    const handleOnRemoveFile = (data) => {
        // console.log('---------------------------')
        // console.log(data)
        // console.log('---------------------------')
    }

    const handleSave = () =>{
        var newDoc = firebase
                          .firestore()
                          .collection('organizations')
                          .doc(profile.company)
                          .collection('importedContacts')
                          .doc()

            newDoc
            .set({
                id: newDoc.id,
                createdBy: profile.email,
                authorCompany: profile.company,
                authorID: auth.uid,
                authorFirstName: profile.firstName,
                authorLastName: profile.lastName,
                contactLinkedin: conLink,
                createdAt: new Date()
                
            })
            .then(function () {
                //console.log('Document Added ');
                setConLink('')
            })
            .catch(function (error) {
                console.error('Error adding document: ', error);
            });
    }

    // console.log(!conLink.includes("linkedin.com"))

    return (
    <div>
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        {/* <div className="text-lg leading-6 font-medium text-gray-900 flex flex-wrap justify-start">
            Import contacts manually or use csv reader
            <div className="mb-4"><ImportExampleV2 /></div>
        </div> */}
        <div className="mt-3 flex sm:mt-0 sm:ml-0">
          {/* <button
            type="button"
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={()=> setShowReader(false)}
          >
            Manual Add  
          </button> 
          <button
            type="button"
            className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={()=> setShowReader(true)}
          >
            Import CSV
          </button> */}
        </div>
        <div >
            {!showReader ?
            <div className="flex">
            <div className="flex mr-10">
                View Example Of Spreadsheet
                <div className=""><ImportExampleV2 /></div> 
            </div>
            <CSVReader
            onDrop={handleOnDrop}
            onError={handleOnError}
            addRemoveButton
            onRemoveFile={handleOnRemoveFile}
            >
                <span>Drop a CSV file here or click to upload from your computer</span>
            </CSVReader>
            </div>
            :
            <div className=" flex">
                <input
                    type="text"
                    name="text"
                    id="text"
                    className="m-1 shadow-sm p-2 focus:outline-none focus:ring focus:border-indigo-300 block w-96 sm:text-sm border-blue-300 border-2 rounded-md"
                    placeholder="Linkedin URL"
                    required
                    autoComplete='off'
                    value={conLink}
                    onChange={(e) => setConLink(e.target.value)}
                />
                <button 
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold px-4 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50"
                    onClick={()=> handleSave()}
                    disabled={!conLink.includes("linkedin.com/in") || checkedContacts.length > 30}
                >
                    Add
                </button>
            </div>
            }
        </div>
      </div>
      <span
      className=""
      >
      <i><b>Note:</b> Max 30 prospects available to bulk search at one time.</i>
      </span>
      </div>
    )
  }